import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-candidate-page',
  templateUrl: './candidate-page.component.html',
  styleUrls: ['./candidate-page.component.css']
})
export class CandidatePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
